import { getGTMEventData } from '@tracking/components/transformer';
import { EVENT_NAMES } from '@tracking/components/constants';

function userExtraDataFormatter(data) {
  const email = window.GTMData?.email ?? null;

  return getGTMEventData(EVENT_NAMES.SET_USER_ATTRIBUTE, email, data);
}

export default userExtraDataFormatter;
